import { EDataType } from 'src/modules/network-configuration/models/node-data';

export enum ExportFileType {
  EXCEL = 'xlsx',
  LIBREOFFICE = 'ods',
  CSV = 'csv',
}

export enum ExportDataType {
  SWITCHES = 'switches',
  DEVICE_IP_VLAN = 'device_ip_vlan',
  PORT_ASSIGNMENT = 'port_assignment',
  CABLE_TYPE = 'cable_type',
}

/** Report title shown at top of each export type */
export const EXPORT_REPORT_TITLES: Record<ExportDataType, string> = {
  [ExportDataType.SWITCHES]: 'List of Switches',
  [ExportDataType.DEVICE_IP_VLAN]: 'Device IP / VLAN List',
  [ExportDataType.PORT_ASSIGNMENT]: 'Port Assignment',
  [ExportDataType.CABLE_TYPE]: 'Cables List',
};

/** Project info + report title for export header */
export interface ExportHeaderInfo {
  projectName: string;
  companyName?: string;
  companyAddress?: string;
  drawnBy?: string;
  revisionNumber?: string;
  projectNumber?: string;
  responsibleEngineer?: string;
  description?: string;
  reportTitle: string;
}

export interface NodeExportData {
  Name: string;
  Model: string;
  Type: EDataType | string;
  Notes?: string;
  vlanIds?: number[];
  enabledPoe?: boolean;
  IP: {
    ip: string;
    subnetMask: string;
  }[];
  Port: {
    name: string;
    connectNode?: string;
    connectPort?: string;
    vlanIds?: number[];
    untaggedVlan?: string;
    poeEnabled?: boolean;
    isPoeCapable?: boolean;
    dhcpEnabled?: boolean;
  }[];
}

export interface PortAssignmentExportData {
  Name: string;
  Target: string;
  'Target Port': string;
  Source: string;
  'Source Port': string;
  vlanIds: number[];
  untaggedVlan?: string;
  vlanIdsFormatted: string;
  poe: string;
  dhcp: string;
}

export interface CableTypeExportRow {
  Type: string;
  'Length (M)': CableTypeExportItem[];
  Quantity?: number;
}

export interface CableTypeExportItem {
  length: number;
  sourceName: string;
  sourcePort?: string;
  sourceType?: EDataType;
  targetName?: string;
  targetType?: EDataType;
  targetPort?: string;
}
